import { useEffect, useState } from 'react';
import styles from './FastGoals.module.scss';
import Close from '../../assets/icons/Close_MD.svg';

export default function FastGoals() {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('');
  const [newId, setNewId] = useState(null);

  async function load() {
    const res = await fetch('/api/fast-goals');
    const data = await res.json();
    setItems(Array.isArray(data) ? data : []);
  }

  useEffect(() => {
    load();
  }, []);

  async function addGoal() {
    const t = title.trim();
    if (!t) return;

    setTitle('');
    const res = await fetch('/api/fast-goals', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: t }),
    });

    if (!res.ok) return;

    const created = await res.json();
    setItems((prev) => [created, ...prev]);

    setNewId(created.id);
    setTimeout(() => setNewId(null), 450);
  }

  async function toggleGoal(id, next) {
    setItems((prev) =>
      prev.map((g) => (g.id === id ? { ...g, completed: next } : g))
    );

    const res = await fetch(`/api/fast-goals/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ completed: next }),
    });

    if (!res.ok) {
      setItems((prev) =>
        prev.map((g) => (g.id === id ? { ...g, completed: !next } : g))
      );
    }
  }

  async function removeGoal(id) {
    const snapshot = items;
    setItems((prev) => prev.filter((g) => g.id !== id));

    const res = await fetch(`/api/fast-goals/${id}`, { method: 'DELETE' });
    if (!res.ok) setItems(snapshot);
  }

  return (
    <div className={styles.fast__goals}>
      <div className={styles.fast__header}>
        <input
          type='text'
          className={styles.fast__input}
          placeholder='Добавить быструю заметку'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') addGoal();
          }}
        />
        <button className={styles.fast__add} type='button' onClick={addGoal}>
          <img src={Close} alt='' className={styles.fast__icon} />
        </button>
      </div>

      <ul className={styles.fast__list}>
        {items.length === 0 ? (
          <li className={styles.fast__empty}>
            Пока ничего нет, можете добавить сверху
          </li>
        ) : (
          items.map((g) => (
            <li
              key={g.id}
              className={[
                styles.fast__item,
                newId === g.id ? styles.fast__itemEnter : '',
              ].join(' ')}>
              <label className={styles.fast__label}>
                <input
                  type='checkbox'
                  className={styles.fast__checkbox}
                  checked={!!g.completed}
                  onChange={(e) => toggleGoal(g.id, e.target.checked)}
                />
                <span className={styles.fast__customCheckbox} />
                <p className={styles.fast__goal}>{g.title}</p>

                <button
                  type='button'
                  onClick={(e) => {
                    e.stopPropagation();
                    removeGoal(g.id);
                  }}
                  className={styles.fast__del}
                  aria-label='Удалить'>
                  <img src={Close} alt='' className={styles.fast__delIcon} />
                </button>
              </label>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
